export default "__VITE_ASSET__afb9527a__"